import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef, useState } from "react";
import { Plus, Minus } from "lucide-react";

export const FAQSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "\"Je n'aime pas l'IA.\"",
      answer: "Parfait. LUMEN est fait pour toi. Tu n'as pas à aimer : tu as à utiliser. 10 minutes. Et tu juges sur pièce.",
    },
    {
      question: "\"J'ai peur de sonner fake / IA.\"",
      answer: "C'est précisément pour ça qu'il y a le Verrou ADN + les interdictions de langage IA. LUMEN est conçu pour rester toi.",
    },
    {
      question: "\"Je n'aime pas vendre.\"",
      answer: "LUMEN ne t'apprend pas à devenir vendeur. Il t'apprend à être clair et à faire circuler ton message. La vente devient une conséquence : pas une mascarade.",
    },
    {
      question: "\"Je ne suis pas régulier(ère).\"",
      answer: "Justement : LUMEN installe un pipeline. Tu passes de \"quand j'ai envie\" à \"quand c'est simple\".",
    },
    {
      question: "\"Je suis nul(le) en réseaux.\"",
      answer: "Tu n'as pas besoin d'être bon(ne) en réseaux. Tu as besoin d'être bon(ne) en expression structurée. NOVA + PORTAIL.",
    },
    {
      question: "\"Est-ce que ça fonctionne avec toutes les IA ?\"",
      answer: "Oui, on n'est pas sectaires ! Tu peux selon tes préférences utiliser LUMEN avec Gemini, ChatGPT, Claude, Mistral... Les prompts sont conçus pour être universels et s'adapter à ton outil favori.",
    },
    {
      question: "\"Est-ce que je dois avoir un abonnement payant avec l'IA ?\"",
      answer: "LUMEN fonctionne très bien en gratuit, sans problème. Avec un abonnement payant, tu auras accès à plus de contenus en moins de temps et plus de finesse dans les réponses, mais ce n'est absolument pas obligatoire pour obtenir des résultats.",
    },
    {
      question: "\"Et pour les protocoles clients ?\"",
      answer: "NOYAU propose des pratiques non médicales (régulation, journaling, micro-action). Si un sujet dépasse ton cadre : tu orientes vers un professionnel qualifié.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section 
      ref={ref}
      className="section-padding bg-white relative overflow-hidden"
      data-testid="faq-section"
    >
      <div className="lumen-container">
        <div className="max-w-3xl mx-auto">
          {/* Section header */}
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <span className="font-cinzel text-sm tracking-[0.3em] text-gold-metallic uppercase mb-4 block">
              FAQ
            </span>
            <h2 className="section-title font-cormorant text-text-main">
              Objections réelles, <span className="italic text-emerald-700">réponses réelles</span>
            </h2>
          </motion.div>

          {/* FAQ items */}
          <div className="space-y-0">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                className="faq-item"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.4, delay: 0.1 + index * 0.08 }}
              >
                <button
                  className="faq-trigger"
                  onClick={() => toggleFAQ(index)}
                  data-testid={`faq-trigger-${index}`}
                >
                  <span className="pr-4">{faq.question}</span>
                  <span className="faq-icon">
                    {openIndex === index ? (
                      <Minus className="w-5 h-5" />
                    ) : (
                      <Plus className="w-5 h-5" />
                    )}
                  </span>
                </button>
                
                <motion.div
                  initial={false}
                  animate={{
                    height: openIndex === index ? "auto" : 0,
                    opacity: openIndex === index ? 1 : 0,
                  }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <p className="faq-content font-manrope">
                    {faq.answer}
                  </p>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
